<mat-expansion-panel class="mat-elevation-z0" [expanded]="true" id="quickAccessExpansion">
  <mat-expansion-panel-header>
    <mat-panel-title> Quick Access </mat-panel-title>
    <mat-panel-description>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <ef-main-menu></ef-main-menu>
  <ef-report-list></ef-report-list>
</mat-expansion-panel>
